import { Injectable } from '@angular/core';
import { StoragePermissionService } from '../storagePermission/storage-permission.service';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {
  constructor(private _storagePermissionService: StoragePermissionService) {}

  checkSitesArMx(domain: string): void {
    if (domain.includes('ar-landings')) {
      this._storagePermissionService.setCountryCode('AR');
    } else if (domain.includes('.mx')) {
      this._storagePermissionService.setCountryCode('MX');
    }
  }
}
